var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph',{ref:"chart",attrs:{"chart-data":_vm.chart_data}})
}
var staticRenderFns = []

export { render, staticRenderFns }